import { useQuery } from '@tanstack/react-query';
import { API, QUERY_KEYS } from '@config';
import { useActiveOrganizationUuid, useDisplayResponseMessage, useRequest } from '@hooks';

export interface GlobalSearchResult {
  mongo_flow_id: string;
  flow_uuid: string;
  flow_name: string;
  project_uuid: string;
  start: string | null;
  status: string;
  score: number;
  snippet: string;
  matched_node_call_uuid: string | null;
}

interface GlobalSearchResponse {
  results: GlobalSearchResult[];
  total_count: number;
}

const MIN_QUERY_LENGTH = 2;

export const useGlobalFlowSearchQuery = (query: string) => {
  const request = useRequest();
  const organizationUuid = useActiveOrganizationUuid();
  const displayResponseMessage = useDisplayResponseMessage();

  return useQuery<GlobalSearchResponse, Error>({
    enabled: query.length >= MIN_QUERY_LENGTH && !!organizationUuid,
    queryKey: [QUERY_KEYS.FLOW_EXECUTION_SEARCH, query, organizationUuid],
    queryFn: async () => {
      try {
        const params = `q=${encodeURIComponent(query)}&organization_uuid=${organizationUuid}`;
        const { data } = await request<GlobalSearchResponse>(
          API.ANALYTICS_SEARCH_EXECUTIONS(params),
        );
        return data;
      } catch (error) {
        displayResponseMessage('search.error');
        throw error;
      }
    },
    staleTime: 5_000,
    placeholderData: { results: [], total_count: 0 },
  });
};
